'use strict';

const processInclude = require('base/util');

$(document).ready(function() {
    processInclude(require('core/storeLocator/storeFinder'));
    processInclude(require('tealium/tealiumEvents'));
});